module.exports = __webpack_public_path__ + "img/barcode_1.57ba1859.png";